export const HOME = {
  emergentLink: "home-emergent-link",
  getQuoteBtn: "home-get-quote-btn",
  applyNowBtn: "home-apply-now-btn",
  heroTitle: "home-hero-title",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  services: "nav-services",
  quote: "nav-quote",
  careers: "nav-careers",
  reviews: "nav-reviews",
  contact: "nav-contact",
  mobileToggle: "nav-mobile-toggle",
};

export const QUOTE = {
  firstName: "quote-first-name",
  lastName: "quote-last-name",
  phone: "quote-phone",
  email: "quote-email",
  company: "quote-company",
  service: "quote-service",
  date: "quote-date",
  message: "quote-message",
  submit: "quote-submit",
  successAlert: "quote-success-alert",
};

export const CAREER = {
  firstName: "career-first-name",
  lastName: "career-last-name",
  phone: "career-phone",
  email: "career-email",
  street: "career-street",
  apartment: "career-apartment",
  city: "career-city",
  state: "career-state",
  zip: "career-zip",
  experience: "career-experience",
  shift: "career-shift",
  resume: "career-resume",
  message: "career-message",
  submit: "career-submit",
  successAlert: "career-success-alert",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  message: "contact-message",
  submit: "contact-submit",
};
